import React from 'react';
import { SidebarBoundary } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';

import { CsmAppSidebarSkeleton } from './CsmAppSidebarSkeleton.tsx';

export const CsmAppSidebarBoundary = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => (
	<SidebarBoundary
		id="csm-nav4.sidebar.csm-app"
		packageName="jiraNavigationAppsSidebarNav4SidebarsContentCsmApp"
		ufoName="csm-nav4.sidebar.csm-app"
	>
		<Placeholder name="csm-nav4.sidebar.csm-app" fallback={<CsmAppSidebarSkeleton />}>
			{children}
		</Placeholder>
	</SidebarBoundary>
);
